/**
 * @generated SignedSource<<a5741e76164ef595967ea0481e0c8433>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type settingsRoles_role$data = {
  readonly id: string;
  readonly name: string | null;
  readonly notifyProjectOverview: boolean | null;
  readonly timeRegCount: number | null;
  readonly " $fragmentType": "settingsRoles_role";
};
export type settingsRoles_role$key = {
  readonly " $data"?: settingsRoles_role$data;
  readonly " $fragmentSpreads": FragmentRefs<"settingsRoles_role">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsRoles_role",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notifyProjectOverview",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeRegCount",
      "storageKey": null
    }
  ],
  "type": "Role",
  "abstractKey": null
};

(node as any).hash = "107abfa3d0af713306ef6e970ddb5332";

export default node;
